module.exports = __webpack_public_path__ + "img/sx.14935adc.svg";